export default __webpack_public_path__ + "static/media/dimond.22fedaad.mp4";